import { Box } from '@mui/material';
import React from 'react';
import { Range, getTrackBackground } from 'react-range';

const THUMB_COLOR = '#ff2d78';

const RangeInput = (props: RangeInputProps) => {
  const { max, min, onChange, value, disabled = false } = props;
  const values = React.useMemo(() => [value], [value]);

  const handleChange = (nextValues: number[]) => {
    if (nextValues.length > 0) {
      onChange(nextValues[0]);
    }
  };

  return (
    <Range
      disabled={disabled}
      draggableTrack={!disabled}
      max={max}
      min={min}
      onChange={handleChange}
      values={values}
      renderThumb={({ props: thumbProps }) => (
        <Box
          {...thumbProps}
          style={{
            ...thumbProps.style,
            height: '18px',
            width: '18px',
            borderRadius: '50%',
            backgroundColor: disabled ? '#f3a0c0' : THUMB_COLOR,
            border: '3px solid #fff',
            boxShadow: '0 1px 4px rgba(0, 0, 0, 0.28)'
          }}
        />
      )}
      renderTrack={({ props: trackProps, children }) => (
        <div
          onMouseDown={trackProps.onMouseDown}
          onTouchStart={trackProps.onTouchStart}
          style={{
            ...trackProps.style,
            height: '22px',
            display: 'flex',
            width: '100%'
          }}
        >
          <div
            ref={trackProps.ref}
            style={{
              height: '4px',
              width: '100%',
              borderRadius: '999px',
              background: getTrackBackground({
                values,
                colors: [disabled ? '#f3a0c0' : THUMB_COLOR, '#e5e7eb'],
                min,
                max
              }),
              alignSelf: 'center'
            }}
          >
            {children}
          </div>
        </div>
      )}
    />
  );
};

export default RangeInput;

type RangeInputProps = {
  max: number;
  min: number;
  onChange: (value: number) => void;
  value: number;
  disabled?: boolean;
};
